











































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import DjjChart from "@/components/chart/DjjChart.vue";
import ServiksChart from "@/components/chart/ServiksChart.vue";
import HisChart from "@/components/chart/HisChart.vue";
import TandaVitalChart from "@/components/chart/TandaVitalChart.vue";
import storePartograf from "@/store/modules/Partograf";
import CardInfoBayiLahir from "@/components/pemeriksaan/partograf/CardInfoBayiLahir.vue";
import { formatDurasi, isSlotEmpty, pembuatLabel } from "@/utility/PartografHelper";
import TabelObservasi from "@/components/pemeriksaan/partograf/TabelObservasi.vue";

@Component({
  components: { DjjChart, ServiksChart, HisChart, TandaVitalChart, CardInfoBayiLahir, TabelObservasi },
})
export default class PartografPrint extends Vue {
  loading = true;

  get register(): string {
    return this.$route.params.register;
  }
  get partograf(): any {
    return storePartograf.partograf;
  }
  get adaObservasi(): boolean {
    return this.rows.some((row) => !isSlotEmpty(row));
  }

  get rows(): any[] {
    return this.partograf && Array.isArray(this.partograf.partograf)
      ? this.partograf.partograf
      : [];
  }

  // Header identitas (pasien di-load via relasi getByRegister)
  get registerNo(): string {
    const p: any = this.partograf;
    return (p && (p.register_id || (p.pasien && p.pasien.register))) || this.register || "";
  }
  get namaIbu(): string {
    const p: any = this.partograf;
    return (p && p.pasien && p.pasien.nama) || "";
  }
  get umurIbu(): string {
    const p: any = this.partograf;
    return (p && (p.pasien_umur || (p.pasien && p.pasien.umur))) || "";
  }
  get alamatIbu(): string {
    const p: any = this.partograf;
    return (p && p.pasien && (p.pasien.alamat || p.pasien.alamat_ktp)) || "";
  }
  get pembuatPartograf(): string {
    return pembuatLabel(this.partograf);
  }

  // === Getter data chart — sama persis dengan Partograf.vue (agar cetak = tampilan) ===
  get djjData(): any {
    if (this.rows.length > 0) return this.rows.map((item) => item.djj);
    return undefined;
  }
  get nadiData(): any {
    if (this.rows.length > 0) return this.rows.map((item) => item.tv.nadi);
    return undefined;
  }
  get tdData(): any {
    if (this.rows.length > 0)
      return this.rows.map((item) => [item.tv.sistole, item.tv.diastole]);
    return undefined;
  }
  color(val): string | null {
    if (val > 40) return "black";
    if (val >= 20) return "rgb(90, 90, 90)";
    if (val > 0) return "rgb(180, 180, 180)";
    return null;
  }
  get durasiData(): any {
    if (this.rows.length > 0) return this.rows.map((item) => this.color(item.his.durasi));
    return undefined;
  }
  get kontraksiData(): any {
    if (this.rows.length > 0) return this.rows.map((item) => item.his.kontraksi);
    return undefined;
  }
  get hisDataa(): any {
    if (this.rows.length > 0) {
      return {
        durasi: this.rows.map((item) => item.his.durasi),
        kontraksi: this.rows.map((item) => item.his.kontraksi),
      };
    }
    return { durasi: [], kontraksi: [] };
  }
  get serviksData(): any {
    if (this.rows.length > 0) {
      return {
        serviks: this.rows.map((item) => item.serviks),
        kepala: this.rows.map((item) => item.kepala),
        jam: this.rows.map((item) => (item.jam || "").substring(0, 5)),
      };
    }
    return { serviks: [], kepala: [], jam: [] };
  }

  async mounted() {
    this.loading = true;
    try {
      if (this.register) {
        await storePartograf.getPartografByReg(this.register);
      }
    } finally {
      this.loading = false;
    }
  }

  fmtDurasi(menit: any): string {
    return formatDurasi(menit === undefined ? null : menit);
  }

  get ketubanText(): string {
    const p: any = this.partograf;
    if (!p) return "-";
    const status = p.ketuban_status || (p.ketuban_pecah ? "sudah" : "belum");
    if (status === "belum") return "Belum pecah";
    return p.ketuban_pecah ? moment(p.ketuban_pecah).format("DD-MM-YYYY HH:mm") : "Sudah pecah";
  }

  // === Catatan Persalinan & Kala IV (port dari blade DomPDF) ===
  tempatOpts: any = {
    rumah_ibu: "Rumah Ibu",
    puskesmas: "Puskesmas",
    polindes: "Polindes",
    rumah_sakit: "Rumah Sakit",
    klinik_swasta: "Klinik Swasta",
    lainnya: "Lainnya",
  };
  pendampingOpts = ["Bidan", "Suami", "Keluarga", "Teman", "Dukun", "Tidak ada"];
  kalaRujukOpts = ["I", "II", "III", "IV"];
  normalOpts = ["Mengeringkan", "Menghangatkan", "Rangsangan taktil", "Bungkus bayi dan tempatkan di sisi ibu"];
  aspiksiaOpts = ["Mengeringkan", "Bebaskan jalan napas", "Rangsangan taktil", "Menghangatkan", "Bungkus bayi dan tempatkan di sisi ibu"];

  get catatan(): any {
    return (this.partograf && this.partograf.catatan_persalinan) || {};
  }
  get info(): any { return this.catatan.info || {}; }
  get k1(): any { return this.catatan.kala_1 || {}; }
  get k2(): any { return this.catatan.kala_2 || {}; }
  get k3(): any { return this.catatan.kala_3 || {}; }
  get bbl(): any { return this.catatan.bayi_baru_lahir || {}; }
  get atonia(): any { return this.k3.atonia_uteri || {}; }
  get kala4(): any {
    return (this.partograf && this.partograf.kala4_monitoring) || {};
  }
  get kala4rows(): any[] {
    return Array.isArray(this.kala4.rows) ? this.kala4.rows : [];
  }
  // rowspan "Jam Ke" + apakah baris pertama tiap jam (untuk kolom Suhu)
  get k4computed(): any[] {
    const rows = this.kala4rows;
    const out: any[] = [];
    let prev: any = null;
    for (let i = 0; i < rows.length; i++) {
      const jam = rows[i].jam_ke != null ? rows[i].jam_ke : null;
      const first = jam !== prev;
      if (first) {
        let span = 1;
        for (let j = i + 1; j < rows.length; j++) {
          if ((rows[j].jam_ke != null ? rows[j].jam_ke : null) === jam) span++;
          else break;
        }
        out[i] = { firstOfJam: true, rowspan: span, suhuUkur: true };
      } else {
        out[i] = { firstOfJam: false, rowspan: 0, suhuUkur: false };
      }
      prev = jam;
    }
    return out;
  }
  get atoniaAda(): boolean {
    const a = this.atonia;
    return !!(a.kompresi_bimanual || a.metil_ergometrin || a.oksitosin_drip);
  }
  isIn(val: any, arr: any): boolean {
    return Array.isArray(arr) && arr.indexOf(val) !== -1;
  }
  normalChecked(opt: string): boolean {
    const arr = this.bbl.tindakan;
    return this.isIn(opt, arr) || this.isIn(opt.toLowerCase().replace(/ /g, "_"), arr);
  }
  k4td(row: any): string {
    return row.td_sistole != null && row.td_sistole !== ""
      ? row.td_sistole + "/" + (row.td_diastole != null ? row.td_diastole : "")
      : "";
  }

  doPrint() {
    window.print();
  }
}
